import { Component, OnInit } from '@angular/core';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { CommonService } from 'src/app/services/common.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';

@Component({
  standalone: false,
  selector: 'app-companies-rfid-bulkupload-preview',
  templateUrl: './companies-rfid-bulkupload-preview.component.html',
  styleUrls: ['./companies-rfid-bulkupload-preview.component.scss']
})
export class CompaniesRfidBulkuploadPreviewComponent implements OnInit {

  tableHeaders: any[] = [];
  tableBody: any = [];
  guestList: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  validationEr: boolean;
  errDate: any;
  selectAllMemberCard: boolean = false;
  hideShowDataTable: any;
  allNewMemberIdList: any = [];
  data: any;
  url: string;

  constructor(
    private router: Router,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private apiService: ApiService,
    private appStateSrv: AppStateProvider,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {

    this.data = this.dataService.getExcelData();
    if (this.data != null) {
      // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
    }
  }

  reprepareData(tb, th) {
    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        //console.log(body);
        th.forEach((head, headIndex) => {
          // console.log(head)
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })
      })
      // console.log(bdata);
      finalB.push(bdata)
    })
    return finalB
  }

  prepareTableData(tableData) {

    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody

    }
  }

  processApiResponse(data) {
    console.log(data);

    if (data.length > 2000) {
      this.appStateSrv.showToast('Member Card ID cannot exceed 2000');
      return;
    }

    console.log("processAPI res", data)

    this.bulkInviteValidation(data);

    if (data != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      data.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(data)
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  handleFileSelect(evt) {
    this.tableHeaders = [];
    console.log(evt);
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        console.log(data);
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        // this.router.navigate(['/bulk-upload-preview/']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });

    setTimeout(() => {
      this.data = this.dataService.getExcelData();
      if (this.data != null) {
        // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
        this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
      }
    }, 10);

  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

  deleteSelected(inviteData, i) {
    console.log(inviteData)
    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      this.tableBody.splice(i, 1);
    }
    setTimeout(() => {
      this.checkIfSelected(i + '__th');
    }, 10);
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
    // this.bulkInviteValidation(this.tableBody)
  }

  editSelected(from, to, i, type) {

    console.log(i);

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);

        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        setTimeout(() => {
          this.checkIfSelected(i + '__th');
        }, 10);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders));
      }
    }
  }

  checkIfSelected(id: string) {
    console.log(id);
    const ele = document.getElementById(id) as HTMLInputElement;
    console.log(ele.checked);
    return !ele.checked ? 'disabledClick' : '';
  }

  bulkInviteValidation(data) {
    console.log(data)
    console.log(JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")))

    this.validationEr = false;

    JSON.parse(JSON.stringify(data).replace(/\s/g, "")).forEach((res, i) => {
    });

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.RFIDCardNumber == undefined || res.RFIDCardNumber.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.SlNo == undefined || res.SlNo.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
    });
  }

  selectAllHandler() {
    if (this.selectAllMemberCard) { }
  }

  selectedGuest(guestData, index) {

  }

  deleteAllInvites() {
    if (this.selectAllMemberCard) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  send() {

    this.allNewMemberIdList = [];

    for (let i = 0; i < this.guestList.length; i++) {

      const allMemberIdData =
      {
        SerialNumber: this.guestList[i][0],
        MemberCardNo: this.guestList[i][1],
      }
      this.allNewMemberIdList.push(allMemberIdData);
    }

    this.url = APIs.tenantMemberCardBulkUpload;

    const paramobj = {
      // tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      IsActive: "true",
      CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
      MemberCardDetails: this.allNewMemberIdList
    };
    this.apiService.post(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        this.router.navigate(['/companies/companies-list']);
      },
      (err) => console.log('error', err)
    );
  }

  cancelTable() {
    this.tableHeaders = [];
    this.router.navigate(['/companies/companies-list/rfid-bulk-upload']);
    //this.tableHeaders = [];
    //window.location.reload();
  }

  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      // this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj })));
    }).catch(err => {
    });
  }

}
